const { toHTML } = require("@portabletext/to-html");
const { marked } = require("marked");
const { decodeHTMLEntities } = require("./helpers");
const textWithImageComponent = require("./components/text-with-image");
const pullQuoteComponent = require("./components/pull-quote");
const footnoteSection = require("./components/footnote");
const {
  default: mountOverlayComponent,
} = require("../components/overlay-images/initializer");
const videoComponent = require("./components/video");
const audioComponent = require("./components/audio");
const imageWithCaptionComponent = require("./components/image-with-caption");
const slideshowComponent = require("./components/image-slideshow");

marked.setOptions({
  breaks: true,
});

let footnotes = [];

const customComponents = ({ prefix }) => ({
  block: {
    normal: function ({children}) {
      if (children?.includes("iframe")) return `<div class="layout/margin:top:page">${decodeHTMLEntities(children)}</div>`;
      return `<p>${prefix ? `${prefix} ` : ""}${decodeHTMLEntities(marked.parseInline(children))}</p>`;
    },
    endnote: function ({children}) {
      return `<blockquote><p>${decodeHTMLEntities(marked.parseInline(children))}</p></blockquote>`;
    },
  },
  types: {
    textWithImage: (props) => textWithImageComponent({ ...props, footnotes }),
    pullQuote: pullQuoteComponent,
    video: videoComponent,
    audio: audioComponent,
    imageWithCaption: imageWithCaptionComponent,
    footnote: (props) => {
      footnotes.push(props.value);
      const footnoteId = footnotes.length;
      return `<sup class="footnote-ref" id="fnref:${footnoteId}">
          <a href="#fn:${footnoteId}" rel="footnote">${footnoteId}</a>
        </sup>`;
    },
    span: ({children}) => {
      return `<span>${marked.parseInline(children)}</span>`;
    },
    imageSlideshow: (props) => slideshowComponent(props)
  },
});

window.addEventListener("DOMContentLoaded", (e) => {
  const el = document.querySelectorAll("sanity-portable-text");

  el.forEach((item) => {
    const portableTextBlocks = JSON.parse(
      item.getAttribute("data-portable-text")
    );
    const prefix = item.getAttribute("data-prefix");
    item.innerHTML = toHTML(portableTextBlocks, {
      components: customComponents({ prefix }),
    });

    if (footnotes.length > 0)
      item.innerHTML += footnoteSection({ value: footnotes, customComponents });

    item.removeAttribute("data-portable-text");
    footnotes = [];
    endnotes = [];
  });

  mountOverlayComponent();
});
